import { CrudModel } from "./_crud";
import SolutionModel, { GetSolutionsByPlanParams } from "./solution.model";

export class SolutionByPlanAdapter extends CrudModel {
	constructor() {
		super("admin/solution", [], []);
	}

	async search(queryParameters: any) {
		const search = queryParameters.search || {};
		const planIds = search.planIds;

		if (!planIds || planIds.length === 0) {
			return { data: [], total: 0, page: 0, pageCount: 0 };
		}

		const params: GetSolutionsByPlanParams = {
			planIds,
			page: queryParameters.page,
			limit: queryParameters.limit,
			searchParam: queryParameters.searchParam,
		};

		if (search.status) {
			params.status = [search.status];
		}
		if (search.categoryId) {
			params.categoryId = search.categoryId;
		}
		if (search.corporateClientId) {
			params.corporateClientId = search.corporateClientId;
		}
		if (search.isFavorite === true) {
			params.isFavorite = true;
		}
		if (search.isAssociated !== undefined) {
			params.isAssociated = search.isAssociated;
		}

		const response = await SolutionModel.getSolutionsByPlan(params);

		return {
			data: response.data.map(s => ({
				...s,
				categoryName: s.category?.name || "-",
				isAssociated: s.isAssociated ? "Associado" : "Não associado",
			})),
			total: response.total,
			page: response.page,
			pageCount: Math.ceil(response.total / (params.limit || 10)),
		};
	}

	async getDescription() {
		return [];
	}

	async getJoinableFields() {
		return [];
	}
}

export default new SolutionByPlanAdapter();
